import * as React from "react";
import { Card, CardContent, Typography, CardActions, Button, Box, FormControl, FormControlLabel, Radio, Alert, } from "@mui/material";
import { Formik, FormikProps, Form, } from "formik";
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';
import { Link, useMatch } from "react-router-dom";
import RadioGroup from '@mui/material/RadioGroup';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../store/store";
import { customerActionSelector, customerGetDataById, customerUpdateData } from "../../../store/slices/customerActionSlice";
import { Customer } from "../../../types/customer.type";
import Loader from "../../component/Loader";

type CustomerEditPageProps = {
  //
};

const CustomerEditPage: React.FC<any> = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const customerActionReducer = useSelector(customerActionSelector);
  const match = useMatch("/customer/edit/:id");
  const initialValues: Customer = { id: "", customerCode: "", customerPOSCode: "", customerName: "",siteCode:"", active: true };

  React.useEffect(() => {
    let id = match?.params.id;
    dispatch(customerGetDataById(id!));
  }, [])


  const showForm = ({ values, setFieldValue, isSubmitting, touched, errors, handleChange, handleBlur }: FormikProps<Customer>) => {
    return (
      <Form>
        <Card>
          <CardContent sx={{ padding: 4 }}>
            <Typography gutterBottom variant="h5">
              Edit Customer
            </Typography>

            <TextField id="customerCode"
              style={{ marginTop: 16 }}
              fullWidth
              variant="outlined"
              label={t('CustomerCode')}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.customerCode}
              helperText={
                errors.customerCode && touched.customerCode
                  ? errors.customerCode
                  : ''
              }
              error={
                errors.customerCode && touched.customerCode
                  ? true
                  : false
              } />

            <TextField id="customerPOSCode"
              style={{ marginTop: 16 }}
              fullWidth
              variant="outlined"
              label={t('CustomerPOSCode')}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.customerPOSCode}
              helperText={
                errors.customerPOSCode && touched.customerPOSCode
                  ? errors.customerPOSCode
                  : ''
              }
              error={
                errors.customerPOSCode && touched.customerPOSCode
                  ? true
                  : false
              } />

            <TextField id="customerName"
              style={{ marginTop: 16 }}
              fullWidth
              variant="outlined"
              label={t('CustomerName')}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.customerName}
              helperText={
                errors.customerName && touched.customerName
                  ? errors.customerName
                  : ''
              }
              error={
                errors.customerName && touched.customerName
                  ? true
                  : false
              } />

<TextField id="siteCode"
              style={{ marginTop: 16 }}
              fullWidth
              variant="outlined"
              label={t('siteCode')}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.siteCode}
              helperText={
                errors.siteCode && touched.siteCode
                  ? errors.siteCode
                  : ''
              }
              error={
                errors.siteCode && touched.siteCode
                  ? true
                  : false
              } />

            <FormControl component="fieldset" style={{ marginTop: 16 }} fullWidth>
              <RadioGroup row name="active" onChange={(event) => { setFieldValue("active", event.currentTarget.value === "true" ? true : false) }} value={values.active}>
                <FormControlLabel control={<Radio />} value={true} label={t('active')} />
                <FormControlLabel control={<Radio />} value={false} label={t('inactive')} />
              </RadioGroup>
            </FormControl>

            {customerActionReducer.isError && <Alert severity="error">{customerActionReducer.message}</Alert>}

          </CardContent>
          <CardActions>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              sx={{ marginRight: 1 }}
              disabled={customerActionReducer.isFetching}
            >
              {t('btnEdit')}
            </Button>
            <Button component={Link} to="/customer" variant="outlined" fullWidth>
              {t('btnCancel')}
            </Button>
          </CardActions>
        </Card>
      </Form>
    );
  };


  const inputRequired = t('inputRequired');
  const validationSchema = Yup.object().shape({
    customerCode: Yup.string().required(inputRequired),
    customerPOSCode: Yup.string().required(inputRequired),
    customerName: Yup.string().required(inputRequired),
    siteCode: Yup.string().required(inputRequired),
  });


  if (customerActionReducer.isFetching) {
    return <><Loader /></>
  }

  return (
    <Box>
      <Formik
        validationSchema={validationSchema}
        enableReinitialize={true}
        initialValues={customerActionReducer.result ? customerActionReducer.result! : initialValues}
        onSubmit={(values, { setSubmitting }) => {
          dispatch(customerUpdateData(values));
          setSubmitting(false);
        }}
      >
        {(props: any) => showForm(props)}
      </Formik>
    </Box>
  );
};

export default CustomerEditPage;
